export default "__VITE_ASSET__98Bov3$J__"